export default {"src":"/planos/_next/static/media/linkedin-icon.ffa6bbb4.svg","height":16,"width":14,"blurWidth":0,"blurHeight":0};